import { render } from "./PersianDateTimeField.vue?vue&type=template&id=2ca4705d"
import script from "./PersianDateTimeField.vue?vue&type=script&lang=js"
export * from "./PersianDateTimeField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PersianDateTimeField.vue"]])

export default __exports__